module.exports = __webpack_public_path__ + "static/media/instagram-logo.1c344004.svg";